import { handleResponse } from '../../modules/Utils'
import fetchJsonp from 'fetch-jsonp'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
}
export default class GeoNames {
  username = 'g410690'
  countryCode = (lat, lng) => {
    return fetchJsonp(
      `https://secure.geonames.org/countryCodeJSON?formatted=true&lat=${lat}&lng=${lng}&username=${this.username}&style=full`,
      { headers, method: 'GET' }
    ).then(handleResponse)
  }
  timezone = (lat, lng) => {
    return (
      fetchJsonp(
        `https://secure.geonames.org/timezoneJSON?formatted=true&lat=${lat}&lng=${lng}&username=${this.username}&style=full`,
        { headers, method: 'GET' }
      )
        // .then(handleErrors)
        .then(handleResponse)
    )
  }
}
